
export const formatDurationLabel = (duration, includeSecond = false) => {
  const hour = Math.floor(duration / 3600);
  const minute = Math.floor(duration / 60) % 60;
  const second = duration % 60;
  return `${('0' + hour).substr(-2)}:${('0' + minute).substr(-2)}${includeSecond ? `:${('0' + second).substr(-2)}` : ''}`;
};
